/**
 * CUSTOMER FIX Stage 7 — read persisted cart quantity without cartStorage bootstrap (no cycles).
 */

import { validatePersistedCartLines } from './persistedCartValidation.js';

const STORAGE_PREFIX = 'rpapp-customer.shop.cart';
const STORAGE_VERSION = 1;

function buildCartStorageKey(tenantCode: string, kioskId: number): string {
  return `${STORAGE_PREFIX}:${tenantCode}:${kioskId}`;
}

interface PersistedCartV1 {
  readonly v: number;
  readonly lines: unknown;
}

/** Sum line quantities from localStorage cart payload (0 when missing/invalid). */
export function readPersistedCartQuantity(tenantCode: string, kioskId: number): number {
  if (typeof window === 'undefined' || !('localStorage' in window)) {
    return 0;
  }
  const raw = window.localStorage.getItem(buildCartStorageKey(tenantCode, kioskId));
  if (raw === null) {
    return 0;
  }
  try {
    const parsed = JSON.parse(raw) as PersistedCartV1;
    if (parsed.v !== STORAGE_VERSION) {
      return 0;
    }
    const lines = validatePersistedCartLines(parsed.lines);
    if (lines === null) {
      return 0;
    }
    return lines.reduce((sum, line) => sum + line.quantity, 0);
  } catch {
    return 0;
  }
}

const CART_KEY_PREFIX = 'rpapp-customer.shop.cart:';

/** True when any non-registry localStorage key holds a cart payload. */
export function localStorageHasAnyCartPayload(): boolean {
  if (typeof window === 'undefined' || !('localStorage' in window)) {
    return false;
  }
  for (let i = 0; i < window.localStorage.length; i += 1) {
    const key = window.localStorage.key(i);
    if (key === null || !key.startsWith(CART_KEY_PREFIX)) {
      continue;
    }
    if (key === 'rpapp-customer.shop.cart.registry') {
      continue;
    }
    if (key.endsWith(':migrate-probe') || key.endsWith(':probe')) {
      continue;
    }
    return true;
  }
  return false;
}
